module.exports = __webpack_public_path__ + "static/16.7_Later_Middle_Ages-6fec986de8d611dd0304cdc2a6c0a334.pdf";